import type * as React from "react";
export const MyplannActivityIcon = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width={16}
			height={16}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.33398 7.80952H4.33398L5.66732 4L7.33398 12L9.66732 8.33333L11.0007 10L12.6673 7.80952H14.6673"
				stroke="currentColor"
				strokeWidth={1.3}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
